import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PageBookings.css";
import { jsPDF } from "jspdf";

function PageBookings() {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetchBookings();
    }, []);

    const fetchBookings = async () => {
        try {
            const mobile = localStorage.getItem("userMobile");
            const response = await fetch(
                "https://gitstool.in/liquor/shop_app/mybooking.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        cust_ph: mobile,
                    }),
                }
            );

            const data = await response.json();
            if (data.status === "success") {
                setBookings(data.records);
            } else {
                setError(data.message || "Unable to fetch bookings.");
            }
        } catch (err) {
            console.error(err);
            setError("Something went wrong while fetching bookings.");
        }
        setLoading(false);
    };

    const retryPayment = async (booking) => {
        try {
            const response = await fetch(
                "https://gitstool.in/liquor/shop_app/retry_order.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        order_id: booking.order_no,
                    }),
                }
            );

            const data = await response.json();
            console.log("Retry Order Response:", data);
            if (data.status !== "success") {
                alert(data.message || "Unable to retry payment.");
                return;
            }
            const options = {
                key: data.key,
                amount: data.amount,
                currency: data.currency,
                name: "DSIIDC",
                description: "Retry Payment",
                order_id: data.razorpay_order_id,
                handler: async function (response) {

                    try {
                        const verifyResponse = await fetch(
                            "https://gitstool.in/liquor/shop_app/verify_payment_details.php",
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    payment_id:
                                        response.razorpay_payment_id,
                                }),
                            }
                        );

                        const verifyData =
                            await verifyResponse.json();
                            console.log("Verify Payment:", verifyData);

                            if (verifyData.status === "captured") {

                            navigate("/order-success", {
                                state: {
                                    order_id:
                                        verifyData.notes.receipt,
                                    uid_no:
                                        verifyData.notes.ref_no,
                                    dlv_dt:
                                        verifyData.notes.delivery_date,
                                    amount: `₹ ${verifyData.amount}`,
                                },
                            });

                        } else {
                            alert(
                                verifyData.error_description ||
                                "Payment verification failed."
                            );
                        }

                    } catch (err) {
                        console.error(err);
                        alert("Unable to verify payment.");
                    }
                },

                prefill: {
                    contact: localStorage.getItem("userMobile"),
                },
                theme: {
                    color: "#B71C1C",
                },
                modal: {
                    ondismiss: function () {
                        console.log("Retry Payment Cancelled");
                    },
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.on("payment.failed", function (response) {
                console.log("Retry Payment Failed");
                console.log(response);
                alert(response.error.description);
            });

            rzp.open();

        } catch (err) {
            console.error(err);
            alert("Unable to retry payment.");
        }
    };

    const generateBill = (booking) => {

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [145, 90.6]
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const margin = 5;

    let y = 8;

    // ======================================
    // OUTER BORDER
    // ======================================

    doc.setDrawColor(0);
    doc.setLineWidth(0.4);

    doc.rect(
        margin,
        margin,
        pageWidth - (margin * 2),
        pageHeight - (margin * 2)
    );

    // ======================================
    // DSIIDC TITLE
    // ======================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);

    // DSIIDC Logo
doc.addImage(
    "/images/logo.png",
    "PNG",
    pageWidth / 2 - 7,
    y,
    14,
    14
);

y += 18;

    // ======================================
    // SHOP NAME
    // ======================================

    doc.setFontSize(9);

    const shopName = booking.items?.[0]?.shopname || "Liquor Shop";

    doc.text(
        shopName.toUpperCase(),
        pageWidth / 2,
        y,
        { align: "center" }
    );

    y += 5;

    // ======================================
    // SHOP ADDRESS
    // ======================================

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);

    const address = doc.splitTextToSize(
        booking.items?.[0]?.address || "",
        pageWidth - 16
    );

    doc.text(
        address,
        pageWidth / 2,
        y,
        { align: "center" }
    );

    y += address.length * 3.5;

    // ======================================
    // DIVIDER
    // ======================================

    y += 2;

    doc.line(
        margin + 2,
        y,
        pageWidth - margin - 2,
        y
    );

    y += 6;

// ======================================
// TAX INVOICE
// ======================================

doc.setFont("helvetica", "bold");
doc.setFontSize(8.5);

doc.text(
    "TAX INVOICE",
    pageWidth / 2,
    y,
    { align: "center" }
);

y += 5;

// Bill Generated On
doc.setFont("helvetica", "normal");
doc.setFontSize(6.5);

const generatedOn = new Date().toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
});

doc.text(
    `Bill Generated On : ${generatedOn}`,
    pageWidth / 2,
    y,
    { align: "center" }
);

y += 7;

// ======================================
// ORDER DETAILS HEADER
// ======================================

    doc.setFillColor(235,235,235);

    doc.rect(
        margin + 2,
        y - 4,
        pageWidth - 14,
        6,
        "F"
    );

    doc.setFontSize(7.5);

    doc.text(
        "ORDER DETAILS",
        margin + 4,
        y
    );

    y += 6;

    // ======================================
    // ORDER DETAILS
    // ======================================

    doc.setFont("helvetica","normal");
    doc.setFontSize(6.8);

    const left = margin + 4;

    const lineGap = 4.5;

    doc.text(
        `Customer Mobile No. : ${localStorage.getItem("userMobile") || "-"}`,
        left,
        y
    );
    y += lineGap;

    doc.text(`Order No : ${booking.order_no}`, left, y);
    y += lineGap;

    doc.text(`Order Date : ${booking.order_date}`, left, y);
    y += lineGap;

    doc.text(`Pickup Date : ${booking.delivery_date}`, left, y);
    y += lineGap;

    doc.text(`Payment Status: ${booking.order_status}`, left, y);
    y += lineGap;

    doc.text(`Booking Status: ${booking.booked_status}`, left, y);
    y += 8;

    // ======================================
    // PRODUCT DETAILS HEADER
    // ======================================

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);

    doc.setFillColor(235, 235, 235);

    doc.rect(
        margin + 2,
        y - 4,
        pageWidth - 14,
        6,
        "F"
    );

    doc.text(
        "PRODUCT DETAILS",
        margin + 4,
        y
    );

    y += 8;

    // ======================================
    // PRODUCTS
    // ======================================

    booking.items.forEach((item, index) => {

        // Divider between products
        if (index > 0) {

            doc.setDrawColor(180);

            doc.line(
                margin + 2,
                y,
                pageWidth - margin - 2,
                y
            );

            y += 3;
        }

// Category
doc.setFont("helvetica", "normal");
doc.setFontSize(6.8);

const category = doc.splitTextToSize(
    `Category : ${item.cat_name || "-"}`,
    pageWidth - 18
);

doc.text(
    category,
    margin + 4,
    y
);

y += category.length * 3.5;

// Brand Name
doc.setFont("helvetica", "normal");
doc.setFontSize(6.8);

const brandName = doc.splitTextToSize(
    `Brand Name : ${item.brandname || "-"}`,
    pageWidth - 18
);

doc.text(
    brandName,
    margin + 4,
    y
);

y += brandName.length * 3.5;

        // Quantity
        doc.setFont("helvetica", "normal");
        doc.setFontSize(6.5);

        doc.text(
            `Sold Qty : Q:${item.qty_q}   P:${item.qty_p}   N:${item.qty_n}`,
            margin + 4,
            y
        );

        y += 4;

        // Amount
        doc.text(
            `Amount : Rs. ${item.p_amount}`,
            margin + 4,
            y
        );

        y += 6;

    });

    // ======================================
    // DIVIDER BEFORE TOTAL
    // ======================================

    doc.setDrawColor(0);

    doc.line(
        margin + 2,
        y,
        pageWidth - margin - 2,
        y
    );

    y += 7;

    // ======================================
    // GRAND TOTAL
    // ======================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);

    doc.text(
        "GRAND TOTAL",
        margin + 4,
        y
    );

    doc.text(
        `Rs. ${booking.amount}`,
        pageWidth - margin - 4,
        y,
        { align: "right" }
    );

    y += 6;

    doc.line(
        margin + 2,
        y,
        pageWidth - margin - 2,
        y
    );

    y += 4;

    // ======================================
    // FOOTER
    // ======================================

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);

    doc.text(
        "Thank you for shopping with DSIIDC LTD.",
        pageWidth / 2,
        y,
        {
            align: "center"
        }
    );

    y += 3.5;

    doc.text(
        "Please retain this invoice for future reference.",
        pageWidth / 2,
        y,
        {
            align: "center"
        }
    );

    y += 4.5;

    doc.setFontSize(5.5);


    // ======================================
    // SAVE PDF
    // ======================================

    doc.save(`Invoice_${booking.order_no}.pdf`);

};

const handleCancelBooking = async (booking) => {
    const confirmCancel = window.confirm(
        `Are you sure you want to cancel Order ${booking.order_no}?`
    );

    if (!confirmCancel) return;

    console.log("Sending order_id:", booking.order_no);
console.log("Booking object:", booking);

    try {

        const response = await fetch("https://gitstool.in/liquor/shop_app/cancel_booking.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                order_id: booking.order_no,
            }),
        });

        console.log("HTTP Status:", response.status);
        const result = await response.json();
        console.log("Cancel Booking Response:", result);

        if (
            result.status === "success" ||
            result.success === true
        ) {

            alert("Booking cancelled successfully.");

            // Refresh booking list
            fetchBookings();

        } else {

            alert(result.message || "Unable to cancel booking.");

        }

    } catch (error) {

        console.error(error);
        alert("Something went wrong while cancelling the booking.");

    }

};

        if (loading) {
        return (
            <div className="page-bookings">
                <h2 className="bookings-title">My Bookings</h2>
                <p className="loading-text">Loading bookings...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="page-bookings">
                <h2 className="bookings-title">My Bookings</h2>
                <p className="error-text">{error}</p>
            </div>
        );
    }

    if (bookings.length === 0) {
        return (
            <div className="page-bookings">
                <h2 className="bookings-title">My Bookings</h2>
                <p className="empty-text">No bookings found.</p>
            </div>
        );
    }

    return (

        <div className="page-bookings">

            <h2 className="bookings-title">My Bookings</h2>

            <div className="bookings-container">

                {bookings.map((booking, index) => (

                    <div
                        className="booking-card"
                        key={index}
                    >

                        <div className="booking-header">

    <div className="order-number">
    <div>
        <strong>Order No:</strong> {booking.order_no}
    </div>

    {booking.order_status.toLowerCase() === "paid" &&
     booking.booked_status.toLowerCase() === "booked" && (
        <div className="pickup-otp">
            <strong>Pickup OTP:</strong> {booking.uidno}
        </div>
    )}
</div>

</div>

<div className="booking-details">

    <div className="detail-item">
        <span>Order Date:</span><br />
        {booking.order_date}
    </div>

    <div className="detail-item">
        <span>Delivery Date:</span><br />
        {booking.delivery_date}
    </div>

    <div className="detail-item">
        <span>Amount:</span><br />
        ₹{booking.amount}
    </div>

    <div className="detail-item">
        <span>Payment Status:</span><br />
        <div className={`status ${booking.order_status.toLowerCase()}`}>
            {booking.order_status.toUpperCase()}
        </div>
    </div>

    <div className="detail-item">
        <span>Booking Status:</span><br />
        <div
            className={`booking-status ${booking.booked_status
                .toLowerCase()
                .replace("-", "")}`}
        >
            {booking.booked_status}
        </div>
    </div>

</div>

                        {booking.items.map((item, idx) => (

                            <div
                                className="item-card"
                                key={idx}
                            >

                                <img
                                    className="item-image"
                                    src={`https://gitstool.in/liquor/shop_app/${item.thumb}`}
                                    alt={item.brandname}
                                />

                                <div className="item-info">

                                    <div className="item-brand">
                                        {item.brandname}
                                    </div>

                                    <p>
                                        <strong>Shop:</strong>{" "}
                                        {item.shopname}
                                    </p>

                                    <p>
                                        <strong>Address:</strong>{" "}
                                        {item.address || "N/A"}
                                    </p>

                                    <p>
                                        <strong>Quantity:</strong>{" "}
                                        Q:{item.qty_q}
                                        {" | "}
                                        P:{item.qty_p}
                                        {" | "}
                                        N:{item.qty_n}
                                    </p>

                                    <p>
                                        <strong>Amount:</strong>{" "}
                                        ₹{item.p_amount}
                                    </p>

                                </div>

                            </div>

                        ))}

{/* Generate Bill */}
{booking.order_status.toLowerCase() === "paid" &&
 booking.booked_status.toLowerCase() === "sold" && (

    <button
        className="generate-bill-btn"
        onClick={() => generateBill(booking)}
    >
        Generate Bill
    </button>

)}

{/* Retry Payment */}
{(booking.order_status.toLowerCase() === "pending" ||
booking.order_status.toLowerCase() === "failed") && (

    <button
        className="retry-payment-btn"
        onClick={() => retryPayment(booking)}
    >
        Retry Payment
    </button>

)}

{/* Cancel Booking */}
{booking.order_status.toLowerCase() === "paid" &&
 booking.booked_status.toLowerCase() === "booked" && (
    <button
        className="cancel-booking-btn"
        onClick={() => handleCancelBooking(booking)}
    >
        Cancel Booking
    </button>
)}
            </div>
                ))}
            </div>
       </div>
    );
}

export default PageBookings;